export default {
  'accessibility': {
    'help-label': 'Редактор текста'
  },
  'placeholders': {
    'figcaption': 'Type caption (optional)'
  },
  'popup': {
    'back': 'Назад',
    'link': 'Ссылка',
    'add': 'Добавить',
    'image': 'Изображение',
    'add-image': 'Добавить изображение'
  },
  'shortcuts': {
    'meta-a': 'Выбрать всё',
    'meta-z': 'Undo',
    'meta-shift-z': 'Redo',
    'meta-shift-m': 'Remove inline format',
    'meta-b': 'Bold',
    'meta-i': 'Italic',
    'meta-u': 'Underline',
    'meta-h': 'Superscript',
    'meta-l': 'Subscript',
    'meta-k': 'Link',
    'meta-alt-0': 'Normal text',
    'meta-alt-1': 'Heading 1',
    'meta-alt-2': 'Heading 2',
    'meta-alt-3': 'Heading 3',
    'meta-alt-4': 'Heading 4',
    'meta-alt-5': 'Heading 5',
    'meta-alt-6': 'Heading 6',
    'meta-shift-7': 'Ordered List',
    'meta-shift-8': 'Unordered List',
    'meta-indent': 'Indent',
    'meta-outdent': 'Outdent',
    'meta-shift-backspace': 'Delete',
    'meta-shift-o': 'Add',
    'meta-shift-d': 'Duplicate',
    'meta-shift-up': 'Move up',
    'meta-shift-down': 'Move down'
  },
  'buttons': {
    'add': 'Добавить',
    'html': 'HTML',
    'format': 'Format',
    'bold': 'Жирный',
    'italic': 'Курсив',
    'deleted': 'Deleted',
    'link': 'Ссылка',
    'list': 'Список',
    'image': 'Изображение',
    'indent': 'Indent',
    'outdent': 'Outdent',
    'embed': 'Embed',
    'table': 'Таблица',
    'insert': 'Добавить',
    'save': 'Сохранить',
    'cancel': 'Отменить',
    'delete': 'Удалить',
    'duplicate': 'Дублировать',
    'shortcut': 'Shortcuts',
    'underline': 'Underline',
    'undo': 'Undo',
    'redo': 'Redo',
    'code': 'Code',
    'mark': 'Mark',
    'subscript': 'Subscript',
    'superscript': 'Superscript',
    'kbd': 'Shortcut',
    'image-settings': 'Настройки изображение',
    'column-settings': 'Column settings'
  },
  'blocks': {
    'text': 'Текст',
    'paragraph': 'Параграф',
    'image': 'Изображение',
    'embed': 'Embed',
    'line': 'Разделитель',
    'table': 'Таблица',
    'quote': 'Цитата',
    'pre': 'Код',
    'address': 'Адрес'
  },
  'format': {
    'p': 'Нормальный текст',
    'h1': 'Large Heading',
    'h2': 'Medium Heading',
    'h3': 'Small Heading',
    'h4': 'Heading 4',
    'h5': 'Heading 5',
    'h6': 'Heading 6',
    'address': 'Address',
    'ul': 'Unordered List',
    'ol': 'Ordered List',
    'dl': 'Definition List'
  },
  'embed': {
    'embed': 'Вставка видео',
    'caption': 'Подпись',
    'description': 'Вставьте любой embed/html код или введите URL (только vimeo или youtube видео)',
    'responsive-video': 'Адаптивное видео'
  },
  'image': {
    'or': 'или',
    'alt-text': 'Описание',
    'link': 'Ссылка',
    'width': 'Ширина',
    'caption': 'Caption',
    'link-in-new-tab': 'Открыть ссылку в новой вкладке',
    'url-placeholder': 'Ссылка на изображение',
    'upload-new-placeholder': 'Перетащите, чтобы загрузить новое изображение, <br> или нажмите, чтобы выбрать'
  },
  'link': {
    'link': 'Добавить ссылку',
    'edit-link': 'Редактировать ссылку',
    'unlink': 'Убрать выделенную ссылку',
    'link-in-new-tab': 'Открывать ссылку в новой вкладке',
    'text': 'Текст/подпись',
    'url': 'Адрес (URL ссылки)'
  },
  'table': {
    'width': 'Ширина',
    'nowrap': 'Не переносить',
    'column': 'Столбец',
    'add-head': 'Добавить заголовок',
    'remove-head': 'Удалить заголовок',
    'add-row-below': 'Добавить строку ниже',
    'add-row-above': 'Добавить строку выше',
    'remove-row': 'Удалить строку',
    'add-column-after': 'Добавить столбец после',
    'add-column-before': 'Добавить столбец перед',
    'remove-column': 'Удалить столбец',
    'delete-table': 'Удалить таблицу'
  }
}
